import React from 'react';





const EmailSignatureTab = (props) => {




    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
       
       EmailSignatureTab

        </div>
    );
};

export default EmailSignatureTab;